import { Trans } from "@lingui/react/macro";
import { Select } from "@silversea-ssc/ui-components-react";
import React, { useCallback } from "react";
import * as styles from "./SortBy.module.scss";
import { useSortBy, UseSortByProps } from "react-instantsearch";

const SortSelect: React.FC<Props> = ({ id, items }) => {
  const { currentRefinement, refine, canRefine } = useSortBy({ items });

  const onChange: React.ChangeEventHandler<HTMLSelectElement> = useCallback(
    (event) => {
      event.preventDefault();
      refine(event.target.value);
    },
    [refine]
  );

  return (
    <Select
      id={id}
      variant="transparent"
      value={currentRefinement}
      onChange={onChange}
      dataContentPiece="sort-by-interaction"
      className={styles.select}
      disabled={!canRefine}
    >
      {items.map((i) => (
        <option key={i.value} value={i.value}>
          {i.label}
        </option>
      ))}
    </Select>
  );
};

type Props = {
  id: string;
  items: UseSortByProps["items"];
};
const SortBy: React.FC<Props> = (props) => {
  return (
    <div className={styles.container}>
      <label htmlFor={props.id}>
        <Trans>Sort By</Trans>
      </label>

      <SortSelect {...props} />
    </div>
  );
};

export default SortBy;
